import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_229';
declare var require: (filename: string) => any;
var BigNumber210 = require('bignumber.js');

BigNumber210.config({
  DECIMAL_PLACES: 3,
  EXPONENTIAL_AT: 100,
  FORMAT: {
    groupSize: 3,
    groupSeparator: ',',
    decimalSeparator: '.'
  }
});
const stepsList = [
/*   { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Inmuebles Leasing', listHelp: ['158']}, */
  { text: "1", active: true, completed: false, tooltip: 'Lista de Bienes Inmuebles No Leasing', listHelp: ['350'] }
];

const tableStructure = [
    {id: 'pagador', title: 'Pagador'}, 
    {id: 'origen', title: 'Origen información'}, 
    {id: 'pensionNombre', title: 'Tipo de pensión'}, 
    {id: 'valor', title: 'Valor'},
];


class Form1 {
  id: number;
  pagador: string;
  origen: string;
  tipoPension: string;
  pensionNombre: string;
  valor: string;
  retencion:string;
  aporteSalud:string;
  numMeses:string;
  impuestoExt:string;
  limRentaEx:string;
  controlSugeridaForm: ControlSugeridaForm;
}
class ControlSugeridaForm{
  numNitReportante: string;
  grupos:Array<ControlGrupoVariables>;
}
class ControlGrupoVariables{
  idGrupo:number;
  variable:string;
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-ingresos-pensiones-modal',
  templateUrl: './ingresos-pensiones-modal.component.html',
  styleUrls: ['./ingresos-pensiones-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService
  ]
})
export class IngresosPensionesModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public listaMeses: number[] =  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;

  saveModel = new EventEmitter();
  public showSave:boolean;
  listaTipoPension:any;
  model:DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema(basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  uvt: string;
  
  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<IngresosPensionesModalComponent>,
    private _componentFactory: ComponentFactoryService,
    private _sugeridaSingletonService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    //this.model = this.data;
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();
    this.validateShowSave();

  }

  protected controlStep(direction: DirectionType): void {
  
  }

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.pagador="";
    this.modelForm.tipoPension="0";
    this.modelForm.valor="0";
    this.modelForm.retencion="0";
    this.modelForm.aporteSalud="0";
    this.modelForm.origen="";
    this.modelForm.numMeses="0";
    this.modelForm.impuestoExt="0";
    this.modelForm.limRentaEx="0";


  }
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_351 == undefined){

      this.model.doc.cuerpo.cc_id_351 = []; //pagador
      this.model.doc.cuerpo.cc_id_352 = []; //origen
      this.model.doc.cuerpo.cc_id_353 = []; //tipoPension
      this.model.doc.cuerpo.cc_id_354 = []; //valor
      this.model.doc.cuerpo.cc_id_359 = []; //numMeses
      this.model.doc.cuerpo.cc_id_360 = []; //aporteSalud
      this.model.doc.cuerpo.cc_id_361 = []; //impuestoExt
      this.model.doc.cuerpo.cc_id_362 = []; //retencion
      this.model.doc.cuerpo.cc_id_363 = []; //limRentaEx
      this.model.doc.cuerpo.cs_id_355 = "0";
   
    }  
  }

 

  public operacionCs355(){ 
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valor, suma);
    
    }
     
    if(suma)
      this.model.doc.cuerpo.cs_id_355 = suma;
    else
      this.model.doc.cuerpo.cs_id_355 = '0';  

  }

  private operacionCs363(){
    const numMeses = this.modelForm.numMeses;
    const limRentExcenUVT = "1000";
    const limRentExcenPesos =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.uvt, limRentExcenUVT, true);
    const linRentExcenxNumMeses = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, limRentExcenPesos, numMeses, true);
    const valorMenosSalud = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, this.modelForm.valor, this.modelForm.aporteSalud);
    const valorMenosSaludDivMeses = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, valorMenosSalud, numMeses);
    let numMesesValidado =  "0";
    let sumaCas354_2 = "0";
    let sumaCas360_2 = "0";
    let sumaCas354_3 = "0";
    let sumaCas360_3 = "0";
    if(this.modelForm.tipoPension == '2' || this.modelForm.tipoPension == '3'){
      let sumCas359_2 = "0";
      let sumCas359_3 = "0";
      for(let i=0; i<this.dataSourceBody.length; i++){
        if(this.dataSourceBody[i].tipoPension == '2' ){
            sumCas359_2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].numMeses, sumCas359_2);
            sumaCas354_2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valor, sumaCas354_2);
            sumaCas360_2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].aporteSalud, sumaCas360_2);
        }else if(this.dataSourceBody[i].tipoPension == '3'){
            sumCas359_3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].numMeses, sumCas359_3);
            sumaCas354_3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valor, sumaCas354_3);
            sumaCas360_3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].aporteSalud, sumaCas360_3);
        }
        
      }
      numMesesValidado = numMeses;
    }
    let sumaCas354_14 = "0";
    let sumaCas360_14 = "0";
   
    if(this.modelForm.tipoPension == '1' || this.modelForm.tipoPension == '4'){
      let sumCas359_14 = "0";
      let cas359_14 = [];
      for(let i=0; i<this.dataSourceBody.length; i++){
        if(this.dataSourceBody[i].tipoPension == '1' || this.dataSourceBody[i].tipoPension == '4'){
          sumCas359_14 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].numMeses, sumCas359_14);
          sumaCas354_14 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valor, sumaCas354_14);
          sumaCas360_14 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].aporteSalud, sumaCas360_14);
          cas359_14.push(this.dataSourceBody[i].numMeses);
        }
         
      }
      let mayor = "0";
      for(let i=0; i<cas359_14.length; i++){
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, cas359_14[i], mayor)){
          mayor = cas359_14[i];
        }
      } 
      
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, sumCas359_14, '12'))
        numMesesValidado = mayor;
      else
        numMesesValidado = sumCas359_14;
    }
    let resultado = "0";
    if(this.modelForm.tipoPension == '1' || this.modelForm.tipoPension == '4'){
      const restaCas354_360 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,sumaCas354_14, sumaCas360_14);
      const valorMenosSaludDivMesesValidado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, restaCas354_360, numMesesValidado)
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorMenosSaludDivMesesValidado, limRentExcenPesos)){
        resultado = restaCas354_360;
      }else{
        resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, limRentExcenPesos, numMesesValidado, true);
      }
    }
    let resultado2 = "0"
    if(this.modelForm.tipoPension == '2'){
      const restaCas354_360_2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,sumaCas354_2, sumaCas360_2);
      const valorMenosSaludDivMesesValidado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, restaCas354_360_2, numMesesValidado)
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorMenosSaludDivMesesValidado, limRentExcenPesos)){
        resultado2 = restaCas354_360_2;
      }else{
        resultado2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, limRentExcenPesos, numMesesValidado, true);
      }
    }

    let resultado3 = "0";
    if(this.modelForm.tipoPension == '3'){
      const restaCas354_360_3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,sumaCas354_3, sumaCas360_3);
      const valorMenosSaludDivMesesValidado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, restaCas354_360_3, numMesesValidado)
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorMenosSaludDivMesesValidado, limRentExcenPesos)){
        resultado3 = restaCas354_360_3;
      }else{
        resultado3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, limRentExcenPesos, numMesesValidado, true);
      }
    }
    let sumaRes1_2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultado, resultado2);
    let resultadoFinal = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, sumaRes1_2, resultado3);

    this.modelForm.limRentaEx = resultadoFinal;



   /*  if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, numMesesValidado, numMeses)){}
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,valorMenosSaludDivMeses, limRentExcenPesos)){
      this.modelForm.limRentaEx = valorMenosSalud;
    }else{
      this.modelForm.limRentaEx = linRentExcenxNumMeses;
    }
 */
    /* let valorxNumMeses = "0";
    if(this.modelForm.valor != "" && this.modelForm.valor != "0" && this.modelForm.numMeses != "" && this.modelForm.numMeses != "0"){
     
      valorxNumMeses = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.modelForm.valor, this.modelForm.numMeses.toString());
     
      const valorxNumMesesUVT = this.convertirPesosUvt(valorxNumMeses);
      const limRenExcentaUVT = "12000";
      const limRenExcentaPesos = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.uvt, limRenExcentaUVT, true);
   
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorxNumMesesUVT, limRenExcentaUVT)){ 
        this.modelForm.limRentaEx=valorxNumMeses;
      }else{
        this.modelForm.limRentaEx=limRenExcentaPesos
      }
    } */

    this.redondearFormData();
    
  }

  protected obtenerSumaRentaNoLaboral(){
    let totalSum = "0";
    if(this.model.doc.cuerpo.cc_id_370 != undefined 
      || this.model.doc.cuerpo.cc_id_370.length > 0){
        const itemsRentaNoLaboral = this.model.doc.cuerpo.cc_id_370
        .filter(item => item.v === "4")
        .map(item => item.it);

        const valoresItemsRentaNoLaboral = this.model.doc.cuerpo.cc_id_371
        .filter(item => itemsRentaNoLaboral.includes(item.it))
        .map(item => item.v);
      
        for(let i=0; i<valoresItemsRentaNoLaboral.length; i++){
          totalSum = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,valoresItemsRentaNoLaboral[i], totalSum);
        } 
    
    };
   
    return totalSum;
  }

  public reloadCifras(){
    if(this.modelForm.tipoPension == '4'){
      this.modelForm.retencion = "0";
    }else{
      this.modelForm.impuestoExt = "0";
    }
  }

  private convertirPesosUvt(valorPesos) {
    valorPesos = this.dutilidades.deshacerFormatoMoneda(valorPesos);
    let valorOperacion = new BigNumber210(valorPesos);
    valorOperacion = valorOperacion.div(this.uvt);
    valorOperacion = valorOperacion.toFormat();
    const punto = valorOperacion.indexOf(".") + 1;
    if ((punto > 0) && (valorOperacion.length - punto) > 2)
      valorOperacion = valorOperacion.slice(0, -1);
    return String(valorOperacion);
  }

  
  //////////////////////

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_351.length; i++){
      this.modelForm.id=i;
      this.modelForm.pagador=this.model.doc.cuerpo.cc_id_351[i].v;
      this.modelForm.origen=this.model.doc.cuerpo.cc_id_352[i].v;
      this.modelForm.tipoPension=this.model.doc.cuerpo.cc_id_353[i].v;
      this.modelForm.pensionNombre=this.listaTipoPension[this.model.doc.cuerpo.cc_id_353[i].v-1].nombre;
      this.modelForm.valor=this.model.doc.cuerpo.cc_id_354[i].v;
      this.modelForm.numMeses=this.model.doc.cuerpo.cc_id_359[i].v;
      //this.modelForm.numMeses=this.model.doc.cuerpo.cc_id_359[i].v != '0' ? this.listaMeses[this.model.doc.cuerpo.cc_id_359[i].v-1].toString() : '0';
      this.modelForm.aporteSalud=this.model.doc.cuerpo.cc_id_360[i].v;
      this.modelForm.impuestoExt=this.model.doc.cuerpo.cc_id_361[i].v;
      this.modelForm.retencion=this.model.doc.cuerpo.cc_id_362[i].v;
      this.modelForm.limRentaEx=this.model.doc.cuerpo.cc_id_363[i].v;

      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

protected initializeTablaDesdeSugerida()
{
  let indexModel = this.model.doc.cuerpo.cc_id_351.length;
  if(indexModel==0){
    const fieldsRecovery = ['VAR_3133','VAR_980','VAR_981','VAR_4762','VAR_991','VAR_3136'];
    const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);

    const grupos=[
      ['VAR_3133','VAR_980','VAR_981','VAR_4762','VAR_991'],
      ['VAR_3136']
    ];

    if(resData)
      {
        for(let i=0; i<resData.length; i++){
          for(let j=0; j<resData[i].item.value.length; j++){
            
            this.modelForm.id=indexModel;
            this.modelForm.origen="0";
            this.modelForm.pagador=resData[i].item.numNitInformante[j]+"/"+resData[i].item.nomRazonSocialInformante[j];

            if(resData[i].key=="VAR_3133" || resData[i].key=="VAR_991" ){
              this.modelForm.tipoPension= "1"; 
            }
            if(resData[i].key=="VAR_980" || resData[i].key=="VAR_981" || resData[i].key=="VAR_4762"){
              this.modelForm.tipoPension= "3"; 
            }
            if(this.listaTipoPension[Number(this.modelForm.tipoPension)-1])
              this.modelForm.pensionNombre= this.listaTipoPension[Number(this.modelForm.tipoPension)-1].nombre; 
            
            let itemGrupoFormPorEditar:Form1 = null;

            //0. Buscar el idGrupo al que corresponde la variable. (Siempre lo debe encontrar)
            let idGrupo:number = -1;
            for(let k=0;k<grupos.length;k++){
              if(grupos[k].includes(resData[i].key)){
                idGrupo=k;
                break;
              }
            }

            //1. El nit ya existe? NO ->1:Agregar
            if(this.dataSourceBody.find((el)=>{
              return el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]    
            })==undefined){
              itemGrupoFormPorEditar = null;
            }else{

              //2. Trae array de solo los del NIT
              let dataSourceBodyPorNitRep = this.dataSourceBody.filter((el)=>{
                if(el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]){
                  return el;
                }
              });

              //3. Recorrer array de solo los del NIT
              for(let k=0;k<dataSourceBodyPorNitRep.length;k++){
                //En el registro existe una variable del GRUPO? 
                //  - NO: Debe Editar el registro y deja de buscar
                //  - SI: Siga buscando (al final si todos tienen entonces debe Agregar nuevo registro por que esta todo ocupado)
                let dataGrupo = dataSourceBodyPorNitRep[k].controlSugeridaForm.grupos.find((el=>{return el.idGrupo==idGrupo}));
                if(!dataGrupo){
                  itemGrupoFormPorEditar = dataSourceBodyPorNitRep[k];
                  break;
                }
              }

            }
            
            //4. Si la variable 'itemGrupoFormPorEditar' tiene valor entonces EDITA, si no AGREGA
            if(itemGrupoFormPorEditar){
              this.dataSourceBody = this.dataSourceBody.filter((itemModelForm)=>{
                if(itemModelForm.id == itemGrupoFormPorEditar.id){
                  itemModelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
                  itemModelForm = this.asignarVariablesSugeridasCondicionadas(itemModelForm, idGrupo, String(resData[i].item.value[j]));
                }
                return itemModelForm;
              });
            }else{
              this.modelForm.controlSugeridaForm = new ControlSugeridaForm();
              this.modelForm.controlSugeridaForm.numNitReportante = resData[i].item.numNitInformante[j];
              this.modelForm.controlSugeridaForm.grupos = new Array<ControlGrupoVariables>();
              this.modelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
              this.redondearFormData();
              this.modelForm = this.asignarVariablesSugeridasCondicionadas(this.modelForm, idGrupo, String(resData[i].item.value[j]));
              this.dataSourceBody.push(this.modelForm);
              this.inicializeForm();
              indexModel++;
            }
          }
        }
      }
  }

  this.operacionCs355();
}


private asignarVariablesSugeridasCondicionadas(itemModelForm: Form1, idGrupo:number, valor:string){
  switch(idGrupo){//Depende de la variable array grupos
    case 0:
      itemModelForm.valor=String(valor);
    break;
    case 1:
      itemModelForm.aporteSalud=String(valor);
    break;
    default:
    break;
  }
  return itemModelForm;
}

  public editModeloDesdeForm(){
   
    this.model.doc.cuerpo.cc_id_351[this.modelForm.id].v=this.modelForm.pagador;
    this.model.doc.cuerpo.cc_id_352[this.modelForm.id].v=this.modelForm.origen.toString();
    this.model.doc.cuerpo.cc_id_353[this.modelForm.id].v=this.modelForm.tipoPension.toString();
    this.model.doc.cuerpo.cc_id_354[this.modelForm.id].v=this.modelForm.valor.toString();
    this.model.doc.cuerpo.cc_id_359[this.modelForm.id].v=this.modelForm.numMeses.toString();
    this.model.doc.cuerpo.cc_id_360[this.modelForm.id].v=this.modelForm.aporteSalud.toString();
    this.model.doc.cuerpo.cc_id_361[this.modelForm.id].v=this.modelForm.impuestoExt.toString();
    this.model.doc.cuerpo.cc_id_362[this.modelForm.id].v=this.modelForm.retencion.toString();
    this.model.doc.cuerpo.cc_id_363[this.modelForm.id].v=this.modelForm.limRentaEx.toString();

  }

  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_351.push({it: i, v:this.modelForm.pagador});
    this.model.doc.cuerpo.cc_id_352.push({it: i, v:this.modelForm.origen.toString()});
    this.model.doc.cuerpo.cc_id_353.push({it: i, v:this.modelForm.tipoPension.toString()});
    this.model.doc.cuerpo.cc_id_354.push({it: i, v:this.modelForm.valor.toString()});
    this.model.doc.cuerpo.cc_id_359.push({it: i, v:this.modelForm.numMeses.toString()});
    this.model.doc.cuerpo.cc_id_360.push({it: i, v:this.modelForm.aporteSalud.toString()});
    this.model.doc.cuerpo.cc_id_361.push({it: i, v:this.modelForm.impuestoExt.toString()});
    this.model.doc.cuerpo.cc_id_362.push({it: i, v:this.modelForm.retencion.toString()});
    this.model.doc.cuerpo.cc_id_363.push({it: i, v:this.modelForm.limRentaEx.toString()});

  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_351.splice(index,1);
    this.model.doc.cuerpo.cc_id_352.splice(index,1);
    this.model.doc.cuerpo.cc_id_353.splice(index,1);
    this.model.doc.cuerpo.cc_id_354.splice(index,1);
    this.model.doc.cuerpo.cc_id_359.splice(index,1);
    this.model.doc.cuerpo.cc_id_360.splice(index,1);
    this.model.doc.cuerpo.cc_id_361.splice(index,1);
    this.model.doc.cuerpo.cc_id_362.splice(index,1);
    this.model.doc.cuerpo.cc_id_363.splice(index,1);


    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_351.length;i++){
      this.model.doc.cuerpo.cc_id_351[i].it=i+1;
      this.model.doc.cuerpo.cc_id_352[i].it=i+1;
      this.model.doc.cuerpo.cc_id_353[i].it=i+1;
      this.model.doc.cuerpo.cc_id_354[i].it=i+1;
      this.model.doc.cuerpo.cc_id_359[i].it=i+1;
      this.model.doc.cuerpo.cc_id_360[i].it=i+1;
      this.model.doc.cuerpo.cc_id_361[i].it=i+1;
      this.model.doc.cuerpo.cc_id_362[i].it=i+1;
      this.model.doc.cuerpo.cc_id_363[i].it=i+1;

    }
  }

  public validateFormCompleted():boolean{
    return this.modelForm.pagador==undefined || this.modelForm.pagador==null || this.modelForm.pagador.trim()=="" ||
          this.modelForm.tipoPension==undefined || this.modelForm.tipoPension==null  || this.modelForm.tipoPension=="0" || 
          this.modelForm.numMeses==undefined || this.modelForm.numMeses==null || this.modelForm.numMeses=="0" || 
         this.modelForm.aporteSalud==undefined || this.modelForm.aporteSalud==null ||   
         this.modelForm.valor==undefined || this.modelForm.valor==null || 
         this.modelForm.impuestoExt==undefined || this.modelForm.impuestoExt==null || 
         this.modelForm.retencion==undefined || this.modelForm.retencion==null ||
          this.modelForm.origen==undefined || this.modelForm.origen==null 
  }

  public redondearFormData(){
    this.modelForm.valor=this.dutilidades.redondearValorMoneda(this.modelForm.valor.toString(),true);
    this.modelForm.retencion=this.dutilidades.redondearValorMoneda(this.modelForm.retencion.toString(),true);
    this.modelForm.aporteSalud=this.dutilidades.redondearValorMoneda(this.modelForm.aporteSalud.toString(),true);
    this.modelForm.impuestoExt=this.dutilidades.redondearValorMoneda(this.modelForm.impuestoExt.toString(),true);
    this.modelForm.limRentaEx=this.dutilidades.redondearValorMoneda(this.modelForm.limRentaEx.toString(),true);

  }

  public calcularValoresForm(conservarArt?:boolean){
    this.redondearFormData();

  }

  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
     // this.modelForm.origen = (this.modelForm.origen == "0" || this.modelForm.origen == "1") && this.operacionTabla==this.OPERACION_EDITAR ? "1" : "2";
      if (this.operacionTabla==this.OPERACION_EDITAR){
        this.modelForm.pensionNombre = this.listaTipoPension[Number(this.modelForm.tipoPension)-1].nombre;
        if(this.modelForm.origen=="0"){ 
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });

       // this.modelForm.adquisicionNombre = this.listaModoAdquisicion[Number(this.modelForm.adquisicion)-1].nombre;
       // this.editModeloDesdeForm();
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){ //agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_351.length;
        this.modelForm.origen = "2";
      //  this.modelForm.reportante = "Contribuyente";
        this.modelForm.pensionNombre = this.listaTipoPension[Number(this.modelForm.tipoPension)-1].nombre;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs355();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs355();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
   
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }



  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.operacionCs355();
    this.dialogRef.close("");
  }
  public guardar(){
    //Limpiar modelo y agregar el contenido de la tabla
    this.model.doc.cuerpo.cc_id_351 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.operacionCs363();
      this.addToModeloDesdeForm();
    }

    this.operacionCs355();

    //console.log(this.model) 
    this.saveModel.emit(true);
    this.closeModal(); 
  }
  public borrarTabla(){
    this.dataSourceBody = [];
  }

  protected cleanInput(nameInput: string): void {
    if(this.modelForm[nameInput] == "0" || this.modelForm[nameInput] == "")
      this.modelForm[nameInput] = '';
  }


}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ingresos/ingresos-pensiones/ingresos-pensiones-modal.component.ts